import "./carousel.css";

import {carouselWrapperTemplate} from "./templates/carousel-wrap.js";
import {basicTemplate} from "./templates/basic.js";
import {itemInfoTemplate} from "./templates/item-info.js";
import {itemLabelTemplate} from "./templates/label-template.js";

//import storyData from "./data/story.json";
//import yellowData from "./data/yellow.json";




(async () => {
    let carouselsUrls = [];
    $.each([window.storiesUrl, window.teamsUrl, window.yellowUrl, window.galleriesUrl], function (index, value) {
        if (value !== undefined) {
            carouselsUrls.push(value);
        }
    });
    //console.log('carouselsUrls', carouselsUrls.length, carouselsUrls);
    if (carouselsUrls.length > 0) {
        const fetchPromises = carouselsUrls.map(url => fetch(url).then(res => res.json()));
        console.log(fetchPromises);
        Promise.allSettled(fetchPromises).then(results => {
            results.forEach(result => {
                if (result.status === "fulfilled") {
                    //console.log("Data received:", result.value);
                    const data = result.value;
                    placeCarousel('.base-grid', data);
                } else {
                    console.error("Fetching carousel failed:", result.reason);
                }
            });
        });
    }
})();


//Load and push carousel content into array
export function loadCarouselLiteral(carouselData, initialItem = 0){   
        
    let dataLength = Object.keys(carouselData).length;
    let currentTemplateElements = [];
    for (let i = initialItem; i < dataLength - 1; i++) {
        let currentItem;
        let optionalClasses = carouselData['item_' + i].item_type;
        let newsUrl = carouselData['item_' + i].href;
        let imgSrc = carouselData['item_' + i].img_src;
        let newsTitle = carouselData['item_' + i].item_title;        
        let labelText = carouselData['item_' + i].label_text;        
        let labelOptionalClass = carouselData['item_' + i].label_class;
        let labelIcon;
        if (labelOptionalClass == 'duration-label'){
            labelIcon = '<svg class="icon"><use xlink:href="#icon-play_simp"></use></svg>';
        }
        if (labelOptionalClass == 'photo-label'){
            labelIcon = '<svg class="icon"><use xlink:href="#icon-mingcute_camera-fill"></use></svg>';
        }
        let infoTemplate, labelTemplate = '';        
        
        if ( (carouselData['item_' + i].item_type === 'story') || (carouselData['item_' + i].item_type === 'team') ) {             
            currentItem = basicTemplate(optionalClasses, newsUrl, imgSrc, newsTitle, '');
        } else if (carouselData['item_' + i].item_type === 'yellow'){
            infoTemplate = itemInfoTemplate(labelTemplate, newsTitle);
            currentItem = basicTemplate(optionalClasses, newsUrl, imgSrc, newsTitle, infoTemplate);
        } else {
            labelTemplate = itemLabelTemplate(labelOptionalClass, labelText, labelIcon);
            infoTemplate = itemInfoTemplate(labelTemplate, newsTitle);
            currentItem = basicTemplate(optionalClasses, newsUrl, imgSrc, newsTitle, infoTemplate);
        }     
        
        currentTemplateElements.push(currentItem);
    }
    return currentTemplateElements;
}

//Create Carousel Wrapping Element
function carouselComponent(carouselData){
    let carouselOptionalClasses = 'carousel-slider ' + carouselData['carousel_info'].classes;
    carouselOptionalClasses += carouselData['carousel_info'].row_position ? ' row-' + carouselData['carousel_info'].row_position : '';
    let carouselId = carouselData['carousel_info'].id;
    let carouselUrl = carouselData['carousel_info'].carousel_url;
    let carouselTitle = carouselData['carousel_info'].name;
    
    let carouselWrapperElement = carouselWrapperTemplate(carouselOptionalClasses, carouselId, carouselUrl, carouselTitle);
    
    return carouselWrapperElement;
}

//place Carousel
export function placeCarousel(gridElementIdentifier, carouselData, initialItem = 0){
    let wrapperElement = $(gridElementIdentifier);
    wrapperElement.append(carouselComponent(carouselData));
    $('#' + carouselData['carousel_info'].id ).find('.carousel-content').append(loadCarouselLiteral(carouselData, initialItem));
}


//click event arrows functionality
$('body').on('click', '.carousel-wrapper .view-back:not(.endposition), .carousel-wrapper .view-next:not(.endposition)', function (e) {
    e.preventDefault();
    e.stopPropagation();
    let wrapperElement = $(this).closest('.carousel-wrapper');
    let contentElement = $(this).siblings('.carousel-content');
    let itemMarg = parseInt(contentElement.find('.carousel-item, .livescore-item').first().css('margin-right'));
    let leftMax = contentElement.innerWidth() + itemMarg - wrapperElement.innerWidth();
    let itemsPerSlide = Math.floor(  wrapperElement.innerWidth() / ( contentElement.find('.carousel-item, .livescore-item').first().innerWidth() + itemMarg ) );
    let slideWidth = itemsPerSlide * (contentElement.find('.carousel-item, .livescore-item').first().innerWidth() + itemMarg);
    let trX = contentElement.css('transform').replace(/[^0-9\-.,]/g, '').split(',')[4];
    let currentPos = Math.ceil(-trX / slideWidth);    
    let posMax = Math.ceil(contentElement.width() / slideWidth) - 1;

//    console.log('wrapperElement width = ', wrapperElement.innerWidth(), 'contentElement width = ', contentElement.innerWidth());
//    console.log('===========INIT =============');
//    console.log('-trX = ', -trX, 'slideWidth = ', slideWidth);
//    console.log('-trX / slideWidth = ', -trX / slideWidth );
//    console.log('init currentPos = Math.ceil(-trX / slideWidth)', currentPos);
//    console.log('posMax', posMax);

    if ($(this).hasClass('view-next')) {
        currentPos++;
//        console.log('right init currentPos = ', currentPos);
        $(this).siblings('.view-back').removeClass('endposition');
        if (currentPos >= posMax ) {
            //console.log('right ENDPOSITION ');
            $(this).addClass('endposition');
            contentElement.css('-webkit-transform', 'translate3d(' + -leftMax + 'px, 0, 0)');
        } else {
            $(this).removeClass('endposition');
            contentElement.css('-webkit-transform', 'translate3d(' + -currentPos * slideWidth + 'px, 0, 0)');
        }
    } else {
        //console.log('back init, currentPos = ', currentPos);
        $(this).siblings('.view-next').removeClass('endposition');
        if (currentPos <= 1) {
            currentPos = 0;
            $(this).addClass('endposition');
            contentElement.css('-webkit-transform', 'translate3d(0px, 0, 0)');
            //console.log('left ENDPOSITION');
        } else {
            currentPos--;
            //console.log('back else, currentPos = ', currentPos);
            $(this).removeClass('endposition');
            contentElement.css('-webkit-transform', 'translate3d(' + -currentPos * slideWidth + 'px, 0, 0)');
        }
    }

});

window.addEventListener('load', () => {    
    if ($('#schedule-dates').length > 0 && document.documentElement.clientWidth < 1308) {
        requestAnimationFrame(() => {
            let wrapperElement = $('#schedule-dates'); 
            wrapperElement.find('.carousel-content').css('-webkit-transform', 'translate3d(0px, 0, 0)');
            wrapperElement.find('.carousel-wrapper').scrollLeft($('.carousel-item.active').offset().left - 170);
        });
    };
});

//for demo purposes
//placeCarousel('.base-grid', storyData);
//placeCarousel('.base-grid', yellowData);


//console.log('carousel working');
